export const addRelatedLoan = {
  name:'',
  loan_status:'',
  description:''
}
export const RelatedLoanHd = [
  { label: 'Name', sortOption: false },
  { label: 'Loan Status', sortOption: false },
  { label: 'Description', sortOption: false },
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action(s)', sortOption: false },
];
export const errorCode = {
  name:{
    0:'',
    1: 'Please enter Name '
  },
  relatedLoanObj: {
    required: true
  }
}
